import React from 'react';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStatsAccess } from '../../hooks/useStatsAccess';
import { useViewCount } from '../../hooks/useViewCount';
import './style.scss';

const ViewCounter = () => {
  const hasAccess = useStatsAccess();
  const viewCount = useViewCount(hasAccess);

  if (!hasAccess) {
    return null;
  }

  return (
    <p className="view-counter" aria-label="View count">
      <FontAwesomeIcon icon={faEye} className="view-counter__icon" aria-hidden="true" />
      <span>{viewCount !== null ? viewCount.toLocaleString() : '…'}</span>
    </p>
  );
};

export default ViewCounter;
